import { render, staticRenderFns } from "./IconBubbleOverlay.vue?vue&type=template&id=1e84f444&scoped=true&"
import script from "./IconBubbleOverlay.vue?vue&type=script&lang=js&"
export * from "./IconBubbleOverlay.vue?vue&type=script&lang=js&"
import style0 from "./IconBubbleOverlay.vue?vue&type=style&index=0&id=1e84f444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e84f444",
  null
  
)

/* custom blocks */
import block0 from "./IconBubbleOverlay.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports